import { memo } from 'react'

import CardCustom from './CardCustom'
import './cards-custom.scss'

interface CardsProps {
  cards: CardItem[]
}
const CardsCustom = ({ cards }: CardsProps) => {
  return (
    <div className="cards-custom">
      {cards?.map((c, i) => (
        <CardCustom card={c} key={i} />
      ))}
    </div>
  )
}

export default memo(CardsCustom)
